import { render, staticRenderFns } from "./company-contact-form.vue?vue&type=template&id=bcb950e0&"
import script from "./company-contact-form.vue?vue&type=script&lang=js&"
export * from "./company-contact-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports